import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import axios from "../../API/axios";

import MobileHeader from '../../components/header/MobileHeader';
import LoginHeader from '../../components/header/LoginHeader';
import NonLoginHeader from '../../components/header/NonLoginHeader';
import CRHeader from '../../components/header/CRHeader';
import InstituteHeader from '../../components/header/InstituteHeader';
import LoginMobileHeader from '../../components/header/LoginMobileHeader';
import InstituteMobileHeader from '../../components/header/InstituteMobileHeader';
import CRMobileHeader from '../../components/header/CRMobileHeader';




const InstituteDetails = () => {
    const { JobId, uid } = useParams();
    const token = localStorage.getItem('token')
    const userUID = localStorage.getItem("userUID");
    const userType = localStorage.getItem("userType");
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState([]);
    console.log("uid", uid);

    const progressRef = useRef();



    // ............................... Institute GetProfile.......................................

    const [profileData, setProfileData] = useState("");

    const getInstituteDetails = async () => {
        console.log("api hit");

        try {
            const response = await
                axios
                    .get(`/Institute/GetProfile?UID=${uid}`);
            console.log(response, "getInstituteDetails");
            setProfileData(response.data.responseData)

            return response;

        } catch (error) {
            console.error('Error fetching institute details:', error);
            throw error;
        }
    };

    useEffect(() => {
        getInstituteDetails();
    }, [uid]);

    // ............................... Institute GetProfile.......................................


    const [isShow, setShow] = useState(false);
    const [toggle, setToggle] = useState({
        key: "",
        status: false,
    });
    const [isShowMobile, setShowMobile] = useState(false);

    const handlePopup = () => {
        const getPopUp = document.querySelector(".sidebar-popup");
        setShow(!isShow);
        !isShow
            ? getPopUp.classList.add("modal-menu--open")
            : getPopUp.classList.remove("modal-menu--open");
    };

    const handleToggle = (key) => {
        if (toggle.key === key) {
            setToggle({
                status: false,
            });
        } else {
            setToggle({
                status: true,
                key,
            });
        }
    };

    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };
    const module = localStorage.getItem('Module')






    return (
        <>
            {/* <section className="single-job-thumb">
                <img
                    src={require("../../assets/images/khoj-images/singlejob.f19680c90ccac510942d.jpg")}
                    alt="images"
                />
            </section> */}
            <>
                {/* Navbar Start */}
                {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                    module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                        module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                                <MobileHeader handleMobile={handleMobile} />}
                {module === 'Candidate' ? <LoginHeader clname="AddProfile" handleMobile={handleMobile} /> :
                    module === 'Institution' ? <InstituteHeader clname="AddProfile" handleMobile={handleMobile} /> :
                        module === 'Company' ? <CRHeader clname="AddProfile" handleMobile={handleMobile} /> :
                            module === 'Recruiter' ? <CRHeader clname="AddProfile" handleMobile={handleMobile} /> :
                                <NonLoginHeader clname="AddProfile" handleMobile={handleMobile} />}
                {/* Navbar End*/}

                <section className="form-sticky fixed-space Institutedetails-hole-content">
                    <div className="profile-resume-main-container pt-3">
                        <div className="profile-resume-heading-cont ">
                            <h4 className="orange-title">
                                <span className="orange-box me-2"></span>
                                Institute{" "}
                            </h4>
                        </div>

                        <div className="InstituteDetail-main-section">
                            <div className="profile-resume-userinfo profile-resume-details mb-3">
                                <div className="Institute-Detail-Container pt-4 pb-4 align-center">
                                    <div className="col-md-3 col-lg-2">
                                        <div className="profile-resume-image d-flex justify-content-center">
                                            <img
                                                src={profileData.logoImage}
                                                alt=""
                                                srcset=""
                                                width={"100px"}
                                                style={{ borderRadius: "50%", height: "100px" }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-6">
                                        <div className="profile-resume-designation f-14 f-600">
                                            {profileData.tagline === null ? (
                                                ""
                                            ) : (
                                                <div className="profile-resume-designation f-14 f-600">
                                                    {profileData.tagline}
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex align-items-center mb-1 Main-resume-username">
                                            <div className="profile-resume-username me-2">
                                                {profileData.name}
                                            </div>
                                        </div>
                                        <div className="d-flex Resume-Skills-Country-Mobile">
                                            {profileData.cityName === null ? (
                                                ""
                                            ) : (
                                                <>
                                                    <div className="profile-resume-country d-flex align-items-center">
                                                        <div className="profile-resume-country-icon d-flex  align-item-center me-3 f-18  f-400">
                                                            <span class="icon-map-pin me-2"></span>
                                                            {profileData.cityName}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-lg-3"></div>
                                </div>
                            </div>
                        </div>



                        <div className="Institute-Detail-Container">
                            <div className="col-lg-4">
                                <div className="cv-form-details po-sticky job-sg single-stick email-cv-form-details profile-resume-userinfo ">
                                    <ul className="list-infor email-list-infor p-0 mb-0">
                                        {/* {profileData.email === null ? "" : ( */}
                                        <li className="mb-0 pb-0">
                                            <div className="category Notification-Text">Email</div>
                                            <div className="detail">
                                                <a href={`mailto:${profileData.email}`}
                                                    onClick={(e) => {
                                                        if (!profileData.email) {
                                                            e.preventDefault();
                                                            alert("Email is not available!");
                                                        }
                                                    }}
                                                >
                                                    {profileData.email || "N.A"}
                                                </a>
                                            </div>
                                        </li>
                                        {/* )} */}

                                        {/* {profileData.contactNo === null ? "" : ( */}
                                        <li className="mb-0 pb-0">
                                            <div className="category Notification-Text">
                                                {" "}
                                                Phone Number
                                            </div>
                                            <div className="detail">
                                                {profileData.contactNo || "N.A."}
                                                {/* <a href={`tel:${profileData.contactNo}`}
                                                    onClick={(e) => {
                                                        if (!profileData.contactNo) {
                                                            e.preventDefault();
                                                            alert("Email is not available!");
                                                        }
                                                    }}
                                                > 
                                                    </div>{profileData.contactNo || "N.A"}
                                                </a>*/}
                                            </div>
                                        </li>
                                        {/* )} */}

                                        {/* {profileData.website === null ? "" : ( */}
                                        <li className="  mb-0 pb-0">
                                            <div className="category Notification-Text">Website</div>
                                            <div className="detail">
                                                {/* {profileData.website || "N.A."} */}
                                                <a
                                                    href={profileData.website ? profileData.website.startsWith("http") ? profileData.website : `https://${profileData.website}` : "#"}
                                                    onClick={(e) => {
                                                        if (!profileData.website) {
                                                            e.preventDefault();
                                                            alert("Website is not available!");
                                                        }
                                                    }}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {profileData.website || "N.A."}
                                                </a>
                                            </div>
                                        </li>
                                        {/* )} */}

                                        {/* {profileData.startedDate === null ? "" : ( */}
                                        <li className="  mb-0 pb-0">
                                            <div className="category Notification-Text">Start Date</div>
                                            <div className="detail">
                                                {/* {moment(profileData.startedDate).format("DD MMM YYYY") ||
                                                    "N.A."} */}
                                                {profileData.startedDate === null || profileData.startedDate === "Invalid date" ?
                                                   <div className="detail">N.A.</div>  : (
                                                        <>
                                                            {moment(profileData.startedDate).format("DD MMM YYYY")}
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </li>
                                        {/* )} */}
                                    </ul>
                                </div>
                            </div>

                            {profileData.about === null ? (
                                ""
                            ) : (
                                <>
                                    <div className="col-lg-7 Aboutme-Container-Profile">
                                        <div className="profile-resume-parent-cont p-4 rounded-3">
                                            {profileData.about === null ? (
                                                ""
                                            ) : (
                                                <div className="profile-resume-about">
                                                    <div className="profile-resume-about-heading f-20  f-800 mb-1">
                                                        About
                                                    </div>

                                                    <div className="profile-resume-about-info">
                                                        <p className="f-16 f-400">{profileData.about}</p>
                                                        <p className="f-16 f-400"></p>
                                                    </div>
                                                </div>
                                            )}
                                            {profileData.description === null ? (
                                                ""
                                            ) : (
                                                <div className="profile-resume-about-info">
                                                    <div className="profile-resume-about-heading f-20  f-800 mb-1">
                                                        Description
                                                    </div>
                                                    <p className="f-16 f-400">{profileData.description}</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                    </div>

                </section>
            </>
        </>
    );
};

export default InstituteDetails;
